import api from '../api';
import Axios from 'axios';
import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';

export interface Correspondencia {
  id: string;
  contratoId: string;
  tipo?: string;
  numeroFornecedorEmitente?: number;
  emitente: string;
  destinatario?: string;
  envioData?: string;
  envioRequerResposta?: boolean;
  envioPrazoDias?: number;
  envioPrazoData?: Date;
  nomeArquivoEnvio?: String;
  localArquivoEnvio?: String;

  envioCodigo?: string;
  envioCodigoRastreio?: string;
  envioAssunto?: string;
  respostaData?: string;

  respostaAssunto: string;
  respostaCodigo: string;
  respostaCodigoRastreio: string;
  respostaSalva: boolean;
  nomeArquivoResposta?: String;
  localArquivoResposta?: String;

  areas: string[];
}

export interface EmitenteDestinatario {
  emitente?: string;
  destinatario?: string;
}

export const getAllCorrespondencias = (contratoId: any) => api.get<Correspondencia[]>(`correspondencias/${contratoId}`);
export const getEmitenteDestinatarioCorrespondencias = (contratoId: any) =>
  api.get<EmitenteDestinatario>(`correspondencias/emitenteDestinatario/${contratoId}`);
export const createCorrespondenciaEnvio = (contratoId: any, file: any, correspondencia: Correspondencia) => {
  const form = new FormData();
  correspondencia.contratoId = contratoId;
  Object.keys(correspondencia).forEach(key => {
    form.append(key, correspondencia[key]);
  });
  form.delete('areas');
  form.append('areas', JSON.stringify(correspondencia.areas));
  form.append('file', file);
  return api.post(`correspondencias`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateResposta = (contratoId: any, file: any, correspondencia: Correspondencia) => {
  const form = new FormData();
  correspondencia.contratoId = contratoId;
  Object.keys(correspondencia).forEach(key => {
    form.append(key, correspondencia[key]);
  });
  form.append('file', file);

  return api.put(`correspondencias/resposta`, form);
};

export const updateEnvio = (contratoId: any, file: any, correspondencia: Correspondencia) => {
  const form = new FormData();
  correspondencia.contratoId = contratoId;
  Object.keys(correspondencia).forEach(key => {
    form.append(key, correspondencia[key]);
  });
  form.delete('areas');
  form.append('areas', JSON.stringify(correspondencia.areas));
  form.append('file', file);

  return api.put(`correspondencias`, form);
};

export const updateCorrespondencia = (Correspondencia: Correspondencia) =>
  api.put(`correspondencias/${Correspondencia.id}`, Correspondencia);
export const deleteCorrespondencia = (id: string) => api.delete(`correspondencias/${id}`);

export const concluir = (values: any) => api.put('correspondencias/concluirCorrespondencia', values);
export const marcarRespostaVisualizada = (values: any) => api.put('correspondencias/marcarRespostaVisualizada', values);

export const download = (path: string, fileName: string) => {
  Axios.get(`/api/correspondencias/contrato/download?path=${path}&fileName=${fileName}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const view = async (path: string, fileName: string) => {
  var url = `/api/correspondencias/contrato/download?path=${path}&fileName=${fileName}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(fileName);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};
